import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    wrapper: { display: 'flex', paddingTop: 5 },
    icon: {
      color: '#ed5a5a',
      fontSize: (props: { size?: string }) => (props.size === 'large' ? 25 : 20)
    },
    message: {
      color: '#ed5a5a',
      fontFamily: 'TTCommons',
      fontSize: (props: { size?: string }) =>
        props.size === 'large' ? 20 : 15,
      fontWeight: 400,
      lineHeight: 1.66,
      display: 'inline',
      marginLeft: 5
    }
  })
);
